import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import classnames from 'classnames';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import './style.scss';

const ListItem = ({
    section = {},
    tagName = '',
    isMobileOrTablet = false,
    i18nPrefix = '',
    getStartedUrl = '',
    getStartedClick = noop,
}) => (
    <div
        className={classnames('list-item', {
            reverse: section.reverseDirection,
        })}
    >
        <div
            className={classnames('img-wrapper', {
                smaller: section.isSmall,
            })}
        >
            <img
                src={section.image}
                width={section.size?.width}
                height={section.size?.height}
                loading="lazy"
                alt={translate(`${i18nPrefix}.how_does_it_work.step_${section.id}.alt`)}
            />
        </div>
        <div className="content-wrapper">
            <small>
                <I18n k={`${i18nPrefix}.how_does_it_work.step_${section.id}.step`} />
            </small>
            <h3 className="text-display-4">
                <I18n k={`${i18nPrefix}.how_does_it_work.step_${section.id}.title`} params={{ tag: tagName }} />
            </h3>
            <p>
                <I18n k={`${i18nPrefix}.how_does_it_work.step_${section.id}.description`} params={{ tag: tagName }} />
            </p>
            {section.showGetStarted && !isMobileOrTablet && (
                <Button
                    className="how-does-it-work-btn"
                    color={Button.COLORS.BLUE}
                    fill={Button.FILLS.GHOST}
                    href={getStartedUrl}
                    onClick={getStartedClick}
                >
                    <I18n k="logo_maker_perseus.general.get_started" />
                </Button>
            )}
        </div>
    </div>
);

ListItem.propTypes = {
    section: PropTypes.shape({
        id: PropTypes.number,
        animation: PropTypes.object,
        reverseDirection: PropTypes.bool,
        showGetStarted: PropTypes.bool,
        isSmall: PropTypes.bool,
        image: PropTypes.string,
        size: PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.number,
        }),
    }),
    tagName: PropTypes.string,
    isMobileOrTablet: PropTypes.bool,
    i18nPrefix: PropTypes.string,
    getStartedUrl: PropTypes.string,
    getStartedClick: PropTypes.func,
};

export default ListItem;
